import { createReducer, on } from '@ngrx/store';

import { taxInvoiceAction } from './tax-invoice.actions';

export const taxInvoiceKey = 'taxInvoice';

export interface TaxInvoiceState {
  taxInvoiceList: any;
  taxInvoiceDetail: any;
  agentTransactionDetail: any;
  createTaxInvoiceResponse: any;
}

export const initialState: TaxInvoiceState = {
  taxInvoiceList: null,
  taxInvoiceDetail: null,
  agentTransactionDetail: null,
  createTaxInvoiceResponse: null
};

export const taxInvoiceReducer = createReducer<TaxInvoiceState>(
  initialState,
  on(taxInvoiceAction.taxInvoiceListResponse, (state, response) => {
    return { ...state, taxInvoiceList: response.response };
  }),
  on(taxInvoiceAction.viewTaxInvoiceResponse, (state, response) => {
    return { ...state, taxInvoiceDetail: response.response };
  }),
  on(taxInvoiceAction.viewAgentTransactionResponse, (state, response) => {
    return { ...state, agentTransactionDetail: response.response };
  }),
  on(taxInvoiceAction.taxInvoiceListReset, (state) => {
    return { ...state, taxInvoiceList: null };
  })
);
